import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

const AnimatedCounter = ({ total = 0 }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, Math.round);

  useEffect(() => {
    const animation = animate(count, total, {
      duration: 0.5, 
    });

    return animation.stop;
  }, [total]);

  return <motion.span>{rounded}</motion.span>;
};

export default AnimatedCounter;